import { render, staticRenderFns } from "./radar_selector.vue?vue&type=template&id=f85287c2&scoped=true"
import script from "./radar_selector.vue?vue&type=script&lang=ts"
export * from "./radar_selector.vue?vue&type=script&lang=ts"
import style0 from "./radar_selector.vue?vue&type=style&index=0&id=f85287c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85287c2",
  null
  
)

export default component.exports